/* @flow */

import { call, put, take } from 'redux-saga/effects'

import type { Action, PollId } from '../types'

import { sagaGet } from '../fetch'
import { apiUrlForPollWhereId } from '../urls'
import {
  BadResponseError,
  SagaMalfunctionError,
  sagaHandleError,
  UnauthorizedError,
} from '../helpers'
import {
  hardcodedPollTypes,
  getCustomersFromLegacyEntities,
  getIconsFromLegacyPolls,
  getExpertOpinionsFromLegacyPolls,
  getPollsFromLegacyPolls,
} from '../legacy'

import { sagaLogoutUnauthorizedUser } from './logout'

import { setIsFetchingPollWhereId } from '../stores/pending'

import { intoCustomersStore } from '../stores/customersStore'
import { intoPollTypesStore } from '../stores/pollTypesStore'
import { intoIconsStore } from '../stores/iconsStore'
import { intoPollsStore } from '../stores/pollsStore'
import { intoExpertOpinionsStore } from '../stores/expertOpinionsStore'
import { intoCursoredUrlsStore } from '../stores/cursoredUrlsStore'

export const FETCH_POLL_INTO_STORE_WHERE_ID: string =
  'opinary/FETCH_POLL_INTO_STORE_WHERE_ID'

export function fetchPollIntoStoreWhereId(id: PollId): Action {
  return {
    type: FETCH_POLL_INTO_STORE_WHERE_ID,
    id,
  }
}

export function* sagaInsertLegacyPollsIntoStore(
  legacyPolls: Array<Object>,
  key: string,
  next: string
): Generator<*, void, *> {
  yield put(intoPollTypesStore(hardcodedPollTypes))
  yield put(intoCustomersStore(getCustomersFromLegacyEntities(legacyPolls)))
  yield put(intoIconsStore(getIconsFromLegacyPolls(legacyPolls)))
  yield put(
    intoExpertOpinionsStore(getExpertOpinionsFromLegacyPolls(legacyPolls))
  )
  const polls = getPollsFromLegacyPolls(legacyPolls)
  yield put(intoPollsStore(polls))
  yield put(intoCursoredUrlsStore(key, next))
}

export function* sagaFetchPollIntoStore(id: PollId): Generator<*, void, *> {
  const response = yield call(sagaGet, apiUrlForPollWhereId(id))
  if (response == null) throw new SagaMalfunctionError()
  if (response.status === 401 || response.status === 403) {
    yield call(sagaLogoutUnauthorizedUser)
    throw new UnauthorizedError()
  }
  if (response.status === 404) return
  if (response.status !== 200) throw new BadResponseError(response)

  const legacyPoll = yield call([response, response.json])
  if (legacyPoll == null) throw new SagaMalfunctionError()

  yield call(sagaInsertLegacyPollsIntoStore, [legacyPoll])
}

export function* sagaRepeatedlyFetchPollIntoStore(): Generator<*, void, *> {
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const action = yield take(FETCH_POLL_INTO_STORE_WHERE_ID)
    if (action == null) throw new SagaMalfunctionError()

    yield put(setIsFetchingPollWhereId(action.id, true))
    try {
      yield call(sagaFetchPollIntoStore, action.id)
    } catch (err) {
      yield call(sagaHandleError, err)
    }
    yield put(setIsFetchingPollWhereId(action.id, false))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/fetchPoll.js